import React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

const Reports: React.LazyExoticComponent<any> = React.lazy(() => import('../components/Reports'));

export default class Loader extends TabLoader {
  /* Override tab loader method */
  public loadTab = (tabId?: string | number): void => {
    const access: boolean = true;
    if (access) {
      window.store.dispatch(removeAll());

      const tabData: TabConfig = {
        id: String(tabId || window.getStr()),
        active: true,
        title: 'Sensors | Reports',
        component: Reports,
        props: {
          report: 'SENSORS_REPORTS',
          title: 'Reports',
        },
      };

      window.store.dispatch(addTab(tabData));
    }
  };
}
